/**
 * Lights component adding ambient and directional light to the scene
 * 
 * @param {*} param0 
 * @returns 
 */
const Lights = ({ sky = 'white', sun = 'white', shadows = false }) => {
    return [
        <ambientLight key="ambient" intensity={0.8} color={sky} />,
        <directionalLight key="directional" position={[0, 2, 3]} intensity={0.2} color={sun} castShadow={shadows} />,
    ];
};

export default Lights;